import React from 'react'
import { connect } from 'react-redux'
import { AutoSizer, List } from 'react-virtualized'

import { redirect, subscriberFilterChanged, subscriberOrderChanged } from '../actions'
import { getUser, getMainViewSubscribers } from '../selectors'

import SubscriberList from '../components/SubscriberList'
import SubscriberTable from '../components/SubscriberTable'
import SubscriberFilter from './SubscriberFilter'

import '../styles/subscriber-view'

class SubscriberView extends React.Component {
    encodeUnicode(str) {
        // first we use encodeURIComponent to get percent-encoded UTF-8,
        // then we convert the percent encodings into raw bytes which
        // can be fed into btoa.
        return btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g,
            function toSolidBytes(match, p1) {
                return String.fromCharCode('0x' + p1);
        }));
      }
    exportAsCsv() {
        this.props.subscribers.map(s => {
            s.name = s.name && s.name.replace(/"/g, '""')
            s.description = s.description && s.description.replace(/"/g, '""')
        })
        const data = 'username;unit;status;name;description;site;last_call\n' + this.props.subscribers.map(s => [s.username, s.unit, s.status, s.name, s.description, s.site_name, s.last_call ? s.last_call : ''].map(v => `"${v}"`).join(';')).join('\n')
        this.props.subscribers.map(s => {
            s.name = s.name && s.name.replace(/""/g, '"')
            s.description = s.description && s.description.replace(/""/g, '"')
        })
        if (navigator.msSaveBlob) { // IE 10+ 
            navigator.msSaveBlob(new Blob([data], { type: 'text/csv;charset=utf-8;' }), "my_data.csv");
        } else {
            var universalBOM = "\uFEFF"
            const encodedUri = "data:text/csv;utf-8," + encodeURIComponent(universalBOM + data)
            var link = document.createElement('a')
            link.setAttribute('href', encodedUri)
            link.setAttribute('download', 'my_data.csv')
            document.body.appendChild(link) // Required for FF
            link.click()
        }
    }
    render() {
        const { filter, sortOrder, subscribers, user, subscriberFilterChanged, subscriberOrderChanged, redirect } = this.props
        return (
            <div className="subscriber-view">
                <div className="toolbar">
                    <SubscriberFilter className="filter" filter={filter} onFilterChanged={subscriberFilterChanged} />
                    <button className="btn" onClick={this.exportAsCsv.bind(this)}>Export as CSV</button>
                </div>
                {/*<SubscriberTable {...{ subscribers, sortOrder }} onSort={subscriberOrderChanged} />*/}
                <SubscriberList {...{ subscribers, user, sortOrder, redirect }} onSort={subscriberOrderChanged} />
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        filter: state.preferences.filter,
        sortOrder: state.preferences.sortOrder,
        subscribers: getMainViewSubscribers(state),
        user: getUser(state)
    }
}

export default connect(mapStateToProps, { redirect, subscriberFilterChanged, subscriberOrderChanged })(SubscriberView)


// WEBPACK FOOTER //
// ./containers/SubscriberView.jsx